import { render, staticRenderFns } from "./PropertyText.vue?vue&type=template&id=f1878210&scoped=true"
import script from "./PropertyText.vue?vue&type=script&lang=js"
export * from "./PropertyText.vue?vue&type=script&lang=js"
import style0 from "./PropertyText.vue?vue&type=style&index=0&id=f1878210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1878210",
  null
  
)

export default component.exports